import Vue from "vue";
import dayjs from "dayjs";

Vue.filter("prettyDate", function(value) {
  if (!value) return "No date available";
  return dayjs(value).format("DD/MM/YYYY, HH:mm");
});
